import { render, staticRenderFns } from "./ChainList.vue?vue&type=template&id=35f74d94&scoped=true&"
import script from "./ChainList.vue?vue&type=script&lang=js&"
export * from "./ChainList.vue?vue&type=script&lang=js&"
import style0 from "./ChainList.vue?vue&type=style&index=0&id=35f74d94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f74d94",
  null
  
)

export default component.exports